 export const questions = 
   [ {
        questionText : "What keeps you busy these days?",
        answerOptions : [ 
            {answerText : "Half time Studying"},
            { answerText : "Round the Clock studying"},
           { answerText : "Recently Graduated"},
          {  answerText : "on Sabbatical"},
          {  answerText : "Employed Part-time"},
          {  answerText : "Seeking Employment"},


    ],
 },{
 questionText : "Who do you call your family ?",
        answerOptions : [ 
            {answerText : "I live alone ."},
            { answerText : "I live in a conjugal/nuclear family ."},
           { answerText : "I live in a joint family ."},

        ]},
        {
 questionText : " Your Current Housing conditions",
        answerOptions : [ 
            {answerText : "I live with my parents ."},
            { answerText : "I share my space with spouse/partner."},
        { answerText : "I live with my Child ."},
            { answerText : "I live with my spouse/partner and a Child ."},
            { answerText : "I live with friends ."},
            { answerText : "others"},

        ]},
        {
        questionText : " Who helps/assists you with household/domestic chores?",
        answerOptions : [ 
            {answerText : "I do everything by myself"},
            { answerText : "Day-time househelp"},
            { answerText : "Full-time househelp"},
            { answerText : "24 hours home assistance/domestic helper"}

        ]},
        {
        questionText : "I start my day with",
        answerOptions : [ 
            { answerText : "Undertake online lessons to improve my skills"},
            { answerText : "Review job openings & apply to my area of expertise"},
            { answerText : "Fulfil my professional roles and responsibilities"},
            { answerText : "Cook Lunch"},
            { answerText : "Meditate/Pray"},
            { answerText : "Monitor the work of househelpers"},
            { answerText : "Have my first meal of the day"},
            { answerText : "Engage in some physical activity"},



        ]},
        {
        questionText : "As I go about my afternoon, I usually",
        answerOptions : [ 
            {answerText : "Watch TV"},
            { answerText : "Cook something to munch"},
            { answerText : "Organize my living space/home"},
            { answerText : "Take a siesta/catnap"}

        ]}

    ]